import React from "react";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader";
import OfferMap from "../../components/OfferMap";

const ContactlensForm = ({
  productData,
  setProductData,
  handleInputChange,
  handleFormattedChange,
  uploading,
  setUploading,
  userInfo,
  onSubmit,
}) => {
  const {
    name,
    price,
    image,
    brand,
    countInStock,
    description,
    usage,
    colour,
    offersIds,
  } = productData;

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post("/api/upload", formData, config);
      setProductData({
        ...productData,
        image: data,
      });
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Form.Group controlId='name' className='mb-3'>
        <Form.Label>Contact lens Name</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter name'
          value={name}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='price' className='mb-3'>
        <Form.Label>Contact lens Price</Form.Label>
        <Form.Control
          required
          type='number'
          placeholder='Enter price'
          value={price}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='image' className='mb-3'>
        <Form.Label>Contact lens Image</Form.Label>
        <Form.Control
          type='text'
          required
          placeholder='Enter image url'
          value={image}
          disabled={image !== ""}
          onChange={handleInputChange}
        />
        <Form.Control
          type='file'
          id='image-file'
          label='Choose File'
          accept='.jpg, .jpeg, .png'
          onChange={uploadFileHandler}
          className='mt-2'
        />
        {uploading && <Loader />}
      </Form.Group>

      <Form.Group controlId='brand' className='mb-3'>
        <Form.Label>Contact lens Brand</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter brand'
          value={brand}
          onChange={handleFormattedChange}
        />
      </Form.Group>

      <Form.Group controlId='countInStock' className='mb-3'>
        <Form.Label>Count In Stock</Form.Label>
        <Form.Control
          required
          type='number'
          placeholder='Enter count in stock(1 = 1 box)'
          value={countInStock}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='description' className='mb-3'>
        <Form.Label>Description</Form.Label>
        <Form.Control
          required
          as='textarea'
          rows={3}
          placeholder='Enter description'
          value={description}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='usage' className='mb-3'>
        <Form.Label>Usage</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter Usage of the Product'
          value={usage}
          onChange={handleFormattedChange}
        />
      </Form.Group>

      <Form.Group controlId='colour' className='mb-3'>
        <Form.Label>Colour</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter Shape of the Product'
          value={colour}
          onChange={handleFormattedChange}
        />
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label>Map Contact lens with Offers</Form.Label>
        <OfferMap
          offersIds={offersIds}
          setOffersIds={(ids) =>
            setProductData({ ...productData, offersIds: ids })
          }
        />
      </Form.Group>

      <Button type='submit' variant='primary' className='mt-3'>
        Add Contact lens
      </Button>
    </Form>
  );
};

export default ContactlensForm;
